module.exports = __webpack_public_path__ + "img/dz.b37c4fcf.svg";